export default __webpack_public_path__ + "static/media/10.9a2ca096.jpeg";